import { cn } from "@/lib/utils";
import type { ScenarioStatus } from "@/lib/scenarios";

const LABELS: Record<ScenarioStatus, string> = {
  draft: "Draft",
  saved: "Saved Scenario",
  committed: "Committed",
};

const STYLES: Record<ScenarioStatus, string> = {
  draft:
    "bg-[hsl(var(--status-info-bg))] text-[hsl(var(--status-info))] border border-[hsl(var(--status-info)/0.3)]",
  saved:
    "bg-[hsl(var(--status-active-bg))] text-[hsl(var(--status-active))] border border-[hsl(var(--status-active)/0.3)]",
  committed:
    "bg-[hsl(var(--status-success-bg))] text-[hsl(var(--status-success))] border border-[hsl(var(--status-success)/0.3)]",
};

export interface StatusBadgeProps {
  status: ScenarioStatus;
  className?: string;
}

/** Visual lifecycle pill: Draft (gray) → Saved Scenario (blue) → Committed (green). */
export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        STYLES[status],
        className,
      )}
    >
      {LABELS[status]}
    </span>
  );
}